import { STAGE } from "@/config/defaultSettings";

/**
 * Attune docs host contract.
 * Keep this centralized so all help-hub links resolve consistently.
 */
export const DOCS_ORIGIN = "https://docs.attunelogic.com";

export const DOCS_PLUGIN_IDS = ["customer", "developer", "proposals"];

export const DOCS_FALLBACK_BY_PLUGIN = {
  customer: "intro",
  developer: "intro",
  proposals: "intro",
};

export function buildDocsUrl({ docsPluginId, docsSlug }) {
  const pluginId = DOCS_PLUGIN_IDS.includes(docsPluginId)
    ? docsPluginId
    : "customer";
  const slug = docsSlug || DOCS_FALLBACK_BY_PLUGIN[pluginId];
  const normalizedSlug = String(slug || "").replace(/^\/+|\/+$/g, "");
  return `${DOCS_ORIGIN}/${pluginId}/${normalizedSlug}`;
}

export function isFeatureEnabled(featureFlags, featureKey) {
  if (!featureKey) return true;
  const value = featureFlags?.[featureKey];
  // Match existing client-side feature semantics:
  // if missing, treat as enabled for backwards compatibility.
  return value === undefined ? true : Boolean(value);
}

export function isFeatureAvailableForAppType(appTypes, appType) {
  if (!Array.isArray(appTypes) || appTypes.length === 0) return true;
  if (!appType) return true;
  return appTypes.includes(appType);
}

export const docsContract = {
  stage: STAGE,
  docsOrigin: DOCS_ORIGIN,
  pluginIds: DOCS_PLUGIN_IDS,
  fallbackByPlugin: DOCS_FALLBACK_BY_PLUGIN,
};

export default docsContract;
